'use client';
import PriceSlider from '@/app/s/components/PriceSlider';
import ArrowDownIcon from '@/assets/icons/ArrowDown.svg';
import FilterDropIcon from '@/assets/icons/FilterDrop.svg';
import FrameIcon from '@/assets/icons/Frame.svg';
import DropDownIcon from '@/assets/icons/drop-down.svg';
import SafeLink from '@/components/SafeLink';
import UKDrawer from '@/components/UKDrawer';
import UKToast from '@/components/UKToast';
import LoadingIcon from '@/components/loadingIcon';
import { useTranslation } from '@/i18n/client';
import { useStores } from '@/models';
import { EXPOSURE_RECORD, sendClickTrack } from '@/tracks/32525';
import { sendClickTrack as sendClickTrackForAddonOne } from '@/tracks/25103';
import { sendClickTrack as sendClickTrackForAddon } from '@/tracks/32535';
import { Box, Button, FormControl, Radio, RadioGroup } from '@mui/material';
import UKCheckbox from '@/components/UKCheckbox';
import UKSwitch from '@/components/UKSwitch';
import cn from 'clsx';
import { observer } from 'mobx-react-lite';
import { useSearchParams } from 'next/navigation';
import { useEffect, useState, useRef, useCallback } from 'react';
import { buildSearchUrl, formatInteger, lockPage, resetLockPage, SortType } from '../../util';
import styles from './index.module.scss';
import { toJS } from 'mobx';
import { spmTrackingUtils } from '@/intl-jdi-common-ssr/utils/spmTrackUtils';

import { TSearchEventTracks, ShopInfoVO } from '@/apis/s/s.interface';
import { styled } from '@mui/material/styles';
interface Props {
  onSearch: () => void;
  keyword: string;
  logid: string;
  searchEventTrack: TSearchEventTracks;
  frontCategoryId?: string;
  baseUrl?: string;
  isAddon?: boolean;
  containerRef: React.RefObject<HTMLDivElement>; // 接收容器引用
  storeId?: string;
  localInfo: any;
  mtest: string;
  highRelatedCategoryIdsForTrack?: string; // 用于埋点的高相关类目id
  shopInfoVO?: ShopInfoVO;
}

const Filter = observer(
  ({
    onSearch,
    keyword,
    logid,
    searchEventTrack,
    frontCategoryId,
    baseUrl,
    isAddon,
    containerRef,
    storeId,
    localInfo,
    mtest,
    highRelatedCategoryIdsForTrack,
    shopInfoVO,
  }: Props) => {
    const { t } = useTranslation();
    const { searchStore } = useStores();
    const [brandCollapse, setBrandCollapse] = useState(false);
    const [priceCollapse, setPriceCollapse] = useState(false);
    const [isOpenFilterDrawer, setIsOpenFilterDrawer] = useState(false);
    const [isArrowDown, setIsArrowDown] = useState(false);
    const [curAttr, setCurAttr] = useState({ id: '', name: '', saleAttrs: [] });

    const [showMore, setShowMore] = useState(false); // 控制是否显示更多品牌
    const [visibleBrandCount, setVisibleBrandCount] = useState(0); // 当前可视的品牌数
    const [showBrandCount, setShowBrandCount] = useState(30); // 品牌弹窗内的品牌展示数
    const [attrShowCountMap, setAttrShowCountMap] = useState<Record<string, number>>({}); //当前可视的扩展属性值项数

    //筛选下拉是否展示
    const [isOverflow, setIsOverflow] = useState(false);
    const filterContainerRef = useRef<HTMLDivElement>(null);

    const [isBrand, setIsBrand] = useState(false);
    const [isSortBy, setIsSortBy] = useState(false);
    const [filterCount, setFilterCount] = useState(0);
    const searchParams = useSearchParams();

    const l1 = Number(searchParams.get('l1')) || 0;
    const l2 = Number(searchParams.get('l2')) || 0;
    const l3 = Number(searchParams.get('l3')) || 0;
    //是否为类目结果页
    const isCagetoryPage = !!(l1 || l2 || l3);

    const channelPageName = searchParams.get('channelPageName') || '';
    searchStore.setChannelPageName(channelPageName);
    const poolIdList = searchParams.get('poolIdList') || '';
    searchStore.setPoolIdList(poolIdList);
    searchStore.setFilterByPoolIds(poolIdList);
    const topKeyFilters = searchParams.get('topKeyFilters') || '';

    const [drawerHeight, setDrawerHeight] = useState<string>();
    const drawerNodeRef = useRef<any>(null);

    const selectedExtAttrsObj = toJS(searchStore.selectedExtAttrs) as Record<string, string[]>;
    // 筛选有选中值和无选中值的属性项
    const selectedExtAttrsForRow = searchStore.extAttrCollection.filter(
      (attr) => (selectedExtAttrsObj?.[attr.id] || []).length > 0,
    );
    const unselectedExtAttrsForRow = searchStore.extAttrCollection.filter(
      (attr) => !selectedExtAttrsForRow.includes(attr),
    );
    // 合并，已选中的属性项排在未选中的前面
    const extAttrs = [...selectedExtAttrsForRow, ...unselectedExtAttrsForRow];

    let fixedCount = 2; //filter和价格排序固定
    if (searchStore.brandExist) fixedCount += 1;
    if (channelPageName) fixedCount += 1;
    const maxExtAttrs = Math.max(0, 8 - fixedCount);
    const extAttrsForRow = extAttrs?.slice(0, maxExtAttrs);
    console.log('----bh---横划条展示的拓展属性', extAttrsForRow);

    useEffect(() => {
      setTimeout(() => {
        if (!drawerNodeRef.current) return;
        const height = calcDrawerHeight({ current: drawerNodeRef.current });
        setDrawerHeight(height);
      }, 0);
    }, [searchStore.filterDropdownVisible, isOpenFilterDrawer]);

    useEffect(() => {
      if (topKeyFilters) {
        const newKeys = topKeyFilters.split('--');
        searchStore.setSelectedTopKeys([...searchStore.selectedTopKeys, ...newKeys]);
      }
    }, []);
    console.log('---bh----topKeyFilters---', topKeyFilters);
    //榜单搜索
    const rankingSearch = searchParams.get('rankingSearch') === 'true';

    useEffect(() => {
      setVisibleBrandCount(searchStore.brandFoldedCount);
    }, [searchStore.brandFoldedCount]);

    useEffect(() => {
      const initial: Record<string, number> = {};
      searchStore.extAttrCollection.forEach((attr) => {
        initial[attr.id] = searchStore.extAttributeFoldedCount || 10;
      });
      setAttrShowCountMap(initial);
    }, [searchStore.extAttributeFoldedCount, searchStore.extAttrCollection]);

    useEffect(() => {
      const hasPriceFilter =
        searchStore.minPrice !== '' &&
        searchStore.maxPrice !== '' &&
        (searchStore.selectedMinPrice !== searchStore.minPrice ||
          searchStore.selectedMaxPrice !== searchStore.maxPrice);

      // 计算被选中的扩展属性的数量（每个扩展属性只要有一个选项被选中，就 +1）
      const hasExtAttrFilter = searchStore.extAttrCollection.reduce((count, extAttr) => {
        const selectedItems =
          (searchStore.selectedExtAttrs as Record<string, string[]>)[extAttr.id] || [];
        return count + (selectedItems.length > 0 ? 1 : 0); // 每个扩展属性最多贡献 +1
      }, 0);

      const count = [
        searchStore.selectedBrandIds.length > 0 ? 1 : 0, // 品牌筛选（最多 +1）
        searchStore.selectedTopKeys.length > 0 ? 1 : 0, // 关键字筛选（最多 +1）
        hasPriceFilter ? 1 : 0, // 价格筛选（最多 +1）
        hasExtAttrFilter, // 扩展属性筛选（可能 +N，每个被选中的扩展属性 +1）
      ].reduce((total, current) => total + current, 0); // 累加所有筛选条件

      setFilterCount(count);
    }, [
      searchStore.selectedBrandIds.length,
      searchStore.selectedTopKeys.length,
      searchStore.selectedMinPrice,
      searchStore.selectedMaxPrice,
      searchStore.minPrice,
      searchStore.maxPrice,
      searchStore.selectedExtAttrs,
      searchStore.extAttrCollection,
    ]);

    // 判断是否需要显示"下拉箭头"按钮
    const showLoadMoreButton = searchStore.brands.length > visibleBrandCount;
    //判断brand弹框是否展示下拉箭头
    const showBrandLoadMoreBtn = searchStore.brands.length > showBrandCount;
    //判断是否需要显示扩展属性的"下拉箭头"按钮
    const showLoadMoreSalesAtterButton = (attrId: string) =>
      attrShowCountMap[attrId] < // 当前已展示量（默认 10）
      (searchStore.extAttrCollection.find((a) => a.id === attrId)?.saleAttrs?.length ?? 0);

    useEffect(() => {
      if (containerRef.current) {
        if (
          searchStore.filterDropdownVisible &&
          searchStore.filterDropdownType !== channelPageName
        ) {
          containerRef.current.style.overflow = 'hidden'; // 禁止滚动
        } else {
          containerRef.current.style.overflow = 'auto'; // 恢复滚动
        }
      }
    }, [searchStore.filterDropdownVisible, containerRef]);

    const [screenHeight, setScreenHeight] = useState(0);

    useEffect(() => {
      setScreenHeight(window.innerHeight);
      const handleResize = () => {
        setScreenHeight(window.innerHeight);
      };

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
      checkOverflow();
      window.addEventListener('resize', checkOverflow);
      return () => window.removeEventListener('resize', checkOverflow);
    }, []);

    const getDynamicHeight = () => {
      // 基准设计尺寸 (1200px)
      const baseHeight = 1200;

      // 计算比例因子 (当前屏幕高度/基准高度)
      const scaleFactor = screenHeight / baseHeight;

      // 基础高度 (以31.4vh为基准)
      const baseVh = 31.4;

      // 根据比例计算动态高度
      const dynamicVh = baseVh * scaleFactor;

      // 设置最小和最大限制 确保移动端弹窗高度不会太小（≥10vh）或太大（≤31.4vh）
      return `${Math.min(31.4, Math.max(10, dynamicVh))}vh`;
    };

    const calcDrawerHeight = (drawerRef: React.RefObject<HTMLElement>): string => {
      console.log('drawerNode', drawerNodeRef.current);
      const drawerTitle = 56;
      const bottomBarHeight = 86;

      const contentHeight = drawerRef.current?.scrollHeight || 0; // 真实内容高度
      console.log('contentHeight', contentHeight);

      const total = contentHeight + drawerTitle;

      const min = 200 - bottomBarHeight;
      const max = Math.floor(window.innerHeight * 0.93 - bottomBarHeight); // 93vh 的 px 值

      const finalPx = Math.min(Math.max(total, min), max);
      console.log('finalPx', finalPx);
      return `${finalPx}px`;
    };

    const getDrawerTitle = () => {
      if (searchStore.filterDropdownType === 'sort') return t('s.filter.sortBy');
      if (searchStore.filterDropdownType === 'brand') return t('s.filter.brand');
      const curAttr = searchStore.extAttrCollection.find(
        (attr) => attr.name === searchStore.filterDropdownType,
      );
      return curAttr?.name || '';
    };

    // 切换过滤条件
    const handleToggleFilter = (e: any) => {
      setBrandCollapse(false); // 打开品牌
      setPriceCollapse(false); // 打开价格
      if (searchStore.extAttrCollection?.length > 3) {
        const collapsed = searchStore.extAttrCollection.map((attr) => ({
          ...attr,
          collapse: true,
        }));
        searchStore.setExtAttrCollection(collapsed);
      }
      setIsOpenFilterDrawer(!isOpenFilterDrawer);
      handleCloseDropDownPopover(e);
      const path = window.location.pathname;
      if (path === '/s-for-addon') {
        isAddon
          ? sendClickTrackForAddon.FreeShippingAddOn_FilterBtn_Click()
          : sendClickTrackForAddonOne.Promotion_FilterBtn_Click();
      } else {
        spmTrackingUtils.spmClick({
          spm: 'a0146.b002226.c00002390.filterBtn',
          biz_type: '',
          event_id: 'Search_ProductList_filterBtn',
          page_id: 'Search_ProductList',
          json_param: JSON.stringify({
            keyWord: keyword,
            categoryId: highRelatedCategoryIdsForTrack || '-100',
            pvid: logid,
            mtest: mtest,
            channelName: 'Search_result',
            shopid: storeId || shopInfoVO?.shopId || '-100',
            ...searchEventTrack,
          }),
          target: e.target as HTMLElement,
        });
      }

      setIsSortBy(false);
      setIsBrand(false);
    };
    const handleToggleArrow = (e: any) => {
      setBrandCollapse(true); // 收起品牌
      setPriceCollapse(true); // 收起价格
      // 收起所有扩展属性
      const collapsedExtAttrs = searchStore.extAttrCollection.map((attr) => ({
        ...attr,
        collapse: true,
      }));
      searchStore.setExtAttrCollection(collapsedExtAttrs);
      setIsOpenFilterDrawer(!isOpenFilterDrawer);
      handleCloseDropDownPopover(e);

      setIsSortBy(false);
      setIsBrand(false);
    };
    // 展开与收起属性浮层
    const handleToggleAttr = (item: any) => {
      const newExtAttrCollection = searchStore.extAttrCollection.map((attr) =>
        // @ts-ignore
        attr.id === item.id ? { ...attr, collapse: !attr.collapse } : attr,
      );
      searchStore.setExtAttrCollection(newExtAttrCollection);
    };

    const handleToggleBrand = () => {
      setBrandCollapse(!brandCollapse);
      setTimeout(() => {
        const height = calcDrawerHeight({ current: drawerNodeRef.current });
        setDrawerHeight(height);
      }, 0);
    };

    const handleTogglePrice = () => {
      setPriceCollapse(!priceCollapse);
      setTimeout(() => {
        const height = calcDrawerHeight({ current: drawerNodeRef.current });
        setDrawerHeight(height);
      }, 0);
    };

    // 重置查询条件
    const handleReset = (e: React.MouseEvent<HTMLButtonElement>) => {
      if (isOpenFilterDrawer) {
        searchStore.reset();
      } else if (searchStore.filterDropdownType === 'brand') {
        searchStore.reset('selectedBrandIds');
      } else if (
        searchStore.extAttrCollection.map((v) => v.name).includes(searchStore.filterDropdownType)
      ) {
        for (const itemId of (searchStore.selectedExtAttrs as any)[curAttr.id] || []) {
          handleToggleAttrItem(curAttr.id, itemId);
        }
      }
      const params = {
        ...searchStore.searchParams,
        channelPageName: channelPageName,
        poolIdList: poolIdList,
      };
      delete params.channelPage;

      onSearch && onSearch();
      e.stopPropagation();
      window.history.pushState(null, '', buildSearchUrl(params, baseUrl));
    };

    const getFilterNameTracks = () => {
      const filterName = [];
      if (searchStore.selectedTopKeys.length > 0) {
        filterName.push({
          attrname: 'topKeys',
          pos: 0,
          attrid: '-100',
          detail: searchStore.selectedTopKeys.map((v) => ({
            text: v,
            loc: searchStore.topKeyVOS?.findIndex((item) => item.id === v),
          })),
        });
      }
      filterName.push({
        attrname: 'price',
        pos: 1,
        attrid: '-100',
        detail: [
          { text: searchStore.minPrice, loc: 0 },
          { text: searchStore.maxPrice, loc: 1 },
        ],
      });
      if (searchStore.selectedBrandIds.length > 0) {
        filterName.push({
          attrname: 'brand',
          pos: 2,
          attrid: '-100',
          detail: searchStore.selectedBrandIds.map((id) => ({
            text: searchStore.brands.find((b) => b.value === id)?.brandName,
            loc: searchStore.brands.findIndex((b) => b.value === id),
          })),
        });
      }
      if (searchStore.extAttrCollection.length > 0) {
        let pos =
          (searchStore.topKeyVOS?.length > 0 ? 1 : 0) +
          (searchStore.brands?.length > 0 ? 1 : 0) +
          (searchStore.minPrice !== '' && searchStore.maxPrice !== '' ? 1 : 0);
        for (const extAttr of searchStore.extAttrCollection) {
          if ((searchStore.selectedExtAttrs as any)?.[extAttr.id]?.length > 0) {
            filterName.push({
              attrname: extAttr.name,
              pos: pos,
              attrid: extAttr.id,
              // @ts-ignore
              detail: (searchStore.selectedExtAttrs as any)?.[extAttr.id].map((id) => ({
                text: extAttr.saleAttrs?.find((a) => a.id === id)?.name,
                loc: extAttr.saleAttrs?.findIndex((a) => a.id === id),
              })),
            });
          }
          pos++;
        }
      }
      return filterName;
    };

    // 显示查询结果
    const handleShowResult = (e: any) => {
      setIsOpenFilterDrawer(false);
      showFilterToast();

      const filterName = getFilterNameTracks();
      const path = window.location.pathname;
      if (path === '/s-for-addon') {
        isAddon
          ? sendClickTrackForAddon.FreeShippingAddOn_FilterLayer_ConfirmBtn_Click()
          : sendClickTrackForAddonOne.Promotion_FilterLayer_ConfirmBtn_Click();
      } else {
        spmTrackingUtils.spmClick({
          spm: 'a0146.b002226.c00002390.filter_Confirm',
          biz_type: '',
          event_id: 'Search_ProductList_filter_Confirm',
          page_id: 'Search_ProductList',
          json_param: JSON.stringify({
            keyWord: keyword,
            categoryId: highRelatedCategoryIdsForTrack || '-100',
            pvid: logid,
            mtest: mtest,
            channelName: 'Search_result',
            filter_name: filterName,
            shopid: storeId || shopInfoVO?.shopId || '-100',
            ...searchEventTrack,
          }),
          target: e.target as HTMLElement,
        });
      }
    };

    // 展开收起品牌面板
    const toggleBrandPanel = () => {
      if (searchStore.filterDropdownType !== 'brand' || !searchStore.filterDropdownVisible) {
        searchStore.setProp('filterDropdownType', 'brand');
        searchStore.setFilterDropdownVisible(true);
        setIsBrand(true);
        setIsSortBy(false);
        lockPage();
      } else {
        searchStore.setProp('filterDropdownType', '');
        searchStore.setFilterDropdownVisible(false);
        setIsBrand(false);
        resetLockPage();
      }
    };

    // in XXX(Deals) 按钮点击
    const handleToggleMiniPagePanel = () => {
      searchStore.toggleSelectedTopKey('channel_page_filter');
      searchStore.setFilterByPoolIds(searchStore.filterByPoolIds ? '' : poolIdList);
      searchStore.setPage(1);
      const params = searchStore.searchParamsWithExtra(
        Object.assign({
          page: 1,
          shopId: storeId,
          shopKeywords: searchStore.shopKeywords,
        }),
      );
      window.history.pushState(null, '', buildSearchUrl(params, baseUrl));
      onSearch && onSearch();
      if (searchStore.selectedTopKeys.includes('channel_page_filter')) {
        showFilterToast();
      }
    };

    const toggleSortPannel = () => {
      if (searchStore.filterDropdownType !== 'sort' || !searchStore.filterDropdownVisible) {
        searchStore.setProp('filterDropdownType', 'sort');
        searchStore.setFilterDropdownVisible(true);
        setIsSortBy(true);
        setIsBrand(false);
        lockPage();
      } else {
        searchStore.setProp('filterDropdownType', '');
        searchStore.setFilterDropdownVisible(false);
        setIsSortBy(false);
        resetLockPage();
      }
    };

    // 展开收起属性面板
    const toggleAttrPanel = (item: any) => {
      if (searchStore.filterDropdownType !== item.name || !searchStore.filterDropdownVisible) {
        searchStore.setProp('filterDropdownType', item.name);
        setCurAttr(item);
        searchStore.setFilterDropdownVisible(true);
        lockPage();
      } else {
        searchStore.setProp('filterDropdownType', '');
        setCurAttr({ id: '', name: '', saleAttrs: [] });
        searchStore.setFilterDropdownVisible(false);
        resetLockPage();
      }
    };

    const handleCloseDropDownPopover = (e: any) => {
      const filterName = getFilterNameTracks();
      const {
        pos,
        attrname: filter_name,
        detail,
      } = filterName.find((v) => v.attrname === searchStore.filterDropdownType) ?? {
        pos: -100,
        attrname: '-100',
        detail: '-100',
      };

      searchStore.setFilterDropdownVisible(false);
      searchStore.setProp('filterDropdownType', '');

      spmTrackingUtils.spmClick({
        spm: 'a0146.b002226.c00002390.Option_Attribute',
        biz_type: '',
        event_id: 'Search_ProductList_Option_Attribute',
        page_id: 'Search_ProductList',
        json_param: JSON.stringify({
          keyWord: keyword,
          categoryId: highRelatedCategoryIdsForTrack || '-100',
          pvid: logid,
          mtest: mtest,
          channelName: 'Search_result',
          pos,
          filter_name,
          detail,
          shopid: storeId || shopInfoVO?.shopId || '-100',
          ...searchEventTrack,
        }),
        target: e.target as HTMLElement,
      });
      setIsBrand(false);
    };

    const showFilterToast = () => {
      if (
        searchStore.resultShowCount === 0 &&
        (searchStore.filterConditionNum > 0 ||
          searchStore.selectedTopKeys?.length > 0 ||
          filterCount > 0)
      ) {
        UKToast.show({
          content: 'No product match your filters. Try broadening your selection.',
          icon: 'warning',
        });
      }
    };

    const getSearchUrl = (params: {
      sortType?: string;
      brandId?: string;
      extAttr?: {
        id: string;
        saleAttrId: string;
      };
      topKey?: string;
    }) => {
      return buildSearchUrl(
        searchStore.searchParamsWithExtra(
          Object.assign(
            {
              ...(storeId
                ? {
                    shopId: storeId,
                    shopKeywords: searchStore.shopKeywords,
                  }
                : {}),
              ...params,
            },
            {
              page: 1,
            },
          ),
        ),
        baseUrl,
      );
    };

    const handleToggleBrandItem = (item: any) => {
      const params = searchStore.searchParamsWithExtra(
        Object.assign(
          {
            brandId: item.value,
          },
          {
            page: 1,
            shopId: storeId,
            shopKeywords: searchStore.shopKeywords,
          },
        ),
      );
      searchStore.setPage(1);
      searchStore.toggleSelectedBrandId(item.value);
      window.history.pushState(null, '', buildSearchUrl(params, baseUrl));
      onSearch && onSearch();
    };

    const handleToggleTopKeyItem = (item: any) => {
      const params = searchStore.searchParamsWithExtra(
        Object.assign(
          { topKey: item.id },
          {
            page: 1,
            shopId: storeId,
            shopKeywords: searchStore.shopKeywords,
          },
        ),
      );
      searchStore.setPage(1);
      searchStore.toggleSelectedTopKey(item.id);
      window.history.pushState(null, '', buildSearchUrl(params, baseUrl));
      onSearch && onSearch();
    };

    const handleToggleAttrItem = (id: string, saleAttrId: string) => {
      const params = searchStore.searchParamsWithExtra(
        Object.assign(
          { extAttr: { id, saleAttrId } },
          {
            page: 1,
            shopId: storeId,
            shopKeywords: searchStore.shopKeywords,
          },
        ),
      );
      searchStore.setPage(1);
      searchStore.toggleSelectedExtAttrs({ id, saleAttrId });
      window.history.pushState(null, '', buildSearchUrl(params, baseUrl));
      onSearch && onSearch();
    };

    //检测横划条上的筛选项是否超出屏幕
    const checkOverflow = useCallback(() => {
      if (filterContainerRef.current) {
        const { scrollWidth, clientWidth } = filterContainerRef.current;
        setIsOverflow(scrollWidth > clientWidth);
      }
    }, []);

    const BpIcon = styled('span')(({ theme }) => ({
      marginBottom: '2px',
      borderRadius: '50%',
      width: 18,
      height: 18,
      boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
      backgroundColor: 'white',
      backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
      '.Mui-focusVisible &': {
        outline: '2px auto rgba(19,124,189,.6)',
        outlineOffset: 2,
      },
      'input:hover ~ &': {
        backgroundColor: '#ebf1f5',
        ...theme.applyStyles('dark', {
          backgroundColor: '#30404d',
        }),
      },
      'input:disabled ~ &': {
        boxShadow: 'none',
        background: 'rgba(206,217,224,.5)',
        ...theme.applyStyles('dark', {
          background: 'rgba(57,75,89,.5)',
        }),
      },
      ...theme.applyStyles('dark', {
        boxShadow: '0 0 0 1px rgb(16 22 26 / 40%)',
        backgroundColor: '#394b59',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))',
      }),
    }));

    const BpCheckedIcon = styled(BpIcon)({
      backgroundColor: 'white',
      backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
      '&::before': {
        display: 'block',
        width: 18,
        height: 18,
        border: '2px solid #1A1A1A',
        borderRadius: 50,
        backgroundImage: 'radial-gradient(#1A1A1A,#1A1A1A 50%,transparent 55%)',
        content: '""',
      },
      // 'input:hover ~ &': {
      // backgroundColor: '#106ba3',
      // },
    });

    return (
      <>
        <div className={styles.filterBoxWrapper}>
          <div
            className={`${styles.searchFilterBox} ${isCagetoryPage ? '' : styles.categoryFilterBox}`}
            data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.01}'
            data-exp={JSON.stringify({
              spm: 'a0146.b002226.c00002390.filterBtn',
              biz_type: '',
              event_id: 'Search_ProductList_filterBtn_Expo',
              json_param: JSON.stringify({
                keyWord: keyword,
                categoryId: highRelatedCategoryIdsForTrack || '-100',
                pvid: logid,
                mtest: mtest,
                channelName: 'Search_result',
                shopid: storeId || shopInfoVO?.shopId || '-100',
                ...searchEventTrack,
              }),
            })}
          >
            {/* 横向滚动右侧filter按钮 */}
            {/* <div className={styles.filterWrapper}>
            <div className={styles.filter} onClick={handleToggleFilter}>
              <div className={styles.filterIconWrapper}>
                <FilterIcon></FilterIcon>
                {searchStore.filterConditionNum > 0 ? (
                  <span className={styles.num}>
                    {searchStore.filterConditionNum <= 99 ? searchStore.filterConditionNum : <span style={{ marginTop: "-4px" }}>...</span>}
                  </span>
                ) : null}
              </div>
              <span className={styles.text}>{t("s.filter.filter")}</span>
            </div>
          </div> */}
            <div
              className={styles.filterBanner}
              ref={filterContainerRef}
              onScroll={(e) => handleCloseDropDownPopover(e)}
            >
              {/* filter */}
              <div
                style={{ alignItems: 'center' }}
                className={cn(styles.tag, {
                  [styles.closeActive]:
                    searchStore.filterConditionNum > 0 ||
                    searchStore.selectedTopKeys.length > 0 ||
                    (searchStore.minPrice !== '' &&
                      searchStore.maxPrice !== '' &&
                      (searchStore.selectedMinPrice !== searchStore.minPrice ||
                        searchStore.selectedMaxPrice !== searchStore.maxPrice)),
                })}
                onClick={(e) => {
                  handleToggleFilter(e);
                }}
                data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.01}'
                data-exp={JSON.stringify({
                  spm: 'a0146.b002226.c00002390.Option',
                  biz_type: '',
                  event_id: 'Search_ProductList_Option_expo',
                  json_param: JSON.stringify({
                    keyWord: keyword,
                    categoryId: highRelatedCategoryIdsForTrack || '-100',
                    pvid: logid,
                    mtest: mtest,
                    channelName: 'Search_result',
                    pos: 0,
                    filter_name: 'filter',
                    shopid: storeId || shopInfoVO?.shopId || '-100',
                    ...searchEventTrack,
                  }),
                })}
              >
                <FrameIcon width={14}></FrameIcon>
                {/* {searchStore.filterConditionNum > 0 ? (
                  <span style={{marginLeft: "4px"}} className={styles.num}>
                    {filterCount}
                  </span>
                ) : null} */}
                {filterCount > 0 ? (
                  <span style={{ marginLeft: '4px' }} className={styles.num}>
                    {filterCount}
                  </span>
                ) : null}

                {filterCount < 1 ? (
                  <span style={{ marginLeft: '4px' }}>{t('s.filter.filter')}</span>
                ) : null}
              </div>
              {/** 排序 */}
              <div
                className={cn(styles.tag, {
                  [styles.opened]: searchStore.filterDropdownType === 'sort',
                  [styles.closeActive]:
                    ((searchStore.sortType === SortType.sort_dredisprice_asc ||
                      searchStore.sortType === SortType.sort_dredisprice_desc) &&
                      searchStore.filterDropdownType !== 'sort') ||
                    isSortBy,
                  [styles.openActive]:
                    (searchStore.sortType === SortType.sort_dredisprice_asc ||
                      searchStore.sortType === SortType.sort_dredisprice_desc) &&
                    searchStore.filterDropdownType === 'sort',
                })}
                onClick={() => {
                  toggleSortPannel();
                }}
                data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.01}'
                data-exp={JSON.stringify({
                  spm: 'a0146.b002226.c00002390.Option',
                  biz_type: '',
                  event_id: 'Search_ProductList_Option_expo',
                  json_param: JSON.stringify({
                    keyWord: keyword,
                    categoryId: highRelatedCategoryIdsForTrack || '-100',
                    pvid: logid,
                    mtest: mtest,
                    channelName: 'Search_result',
                    pos: 0,
                    filter_name: 'sort',
                    shopid: storeId || shopInfoVO?.shopId || '-100',
                    ...searchEventTrack,
                  }),
                })}
              >
                {t('s.filter.sortBy')}
                <ArrowDownIcon width={14}></ArrowDownIcon>
                {/* {searchStore.filterDropdownType === "sort" && <div className={styles.fill}></div>} */}
              </div>
              {/* in Deals(XXX) 按钮点击 */}
              {channelPageName && (
                <div
                  className={cn(styles.tag, {
                    [styles.closeActive]:
                      searchStore.selectedTopKeys.includes('channel_page_filter'),
                  })}
                  onClick={() => {
                    handleToggleMiniPagePanel();
                  }}
                >
                  {t('s.in', {
                    channelPageName: channelPageName,
                    interpolation: { escapeValue: false },
                  })}
                </div>
              )}
              {/*品牌列表筛选项*/}
              {searchStore.brandExist && (
                <div
                  className={cn(styles.tag, {
                    [styles.opened]:
                      searchStore.brands.length > 0 && searchStore.filterDropdownType === 'brand',
                    [styles.closeActive]:
                      (searchStore.selectedBrandIds.length &&
                        searchStore.filterDropdownType !== 'brand') ||
                      isBrand,
                    [styles.openActive]:
                      searchStore.selectedBrandIds.length &&
                      searchStore.filterDropdownType === 'brand',
                  })}
                  onClick={(e) => {
                    console.log();
                    toggleBrandPanel();
                    spmTrackingUtils.spmClick({
                      spm: 'a0146.b002226.c00002390.Option',
                      biz_type: '',
                      event_id: 'Search_ProductList_Option',
                      page_id: 'Search_ProductList',
                      json_param: JSON.stringify({
                        keyWord: keyword,
                        categoryId: highRelatedCategoryIdsForTrack || '-100',
                        pvid: logid,
                        mtest: mtest,
                        channelName: 'Search_result',
                        pos: 1,
                        filter_name: 'brands',
                        shopid: storeId || shopInfoVO?.shopId || '-100',
                        ...searchEventTrack,
                      }),
                      target: e.target as HTMLElement,
                    });
                  }}
                  data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.01}'
                  data-exp={JSON.stringify({
                    spm: 'a0146.b002226.c00002390.Option',
                    biz_type: '',
                    event_id: 'Search_ProductList_Option_expo',
                    json_param: JSON.stringify({
                      keyWord: keyword,
                      categoryId: highRelatedCategoryIdsForTrack || '-100',
                      pvid: logid,
                      mtest: mtest,
                      channelName: 'Search_result',
                      pos: 1,
                      filter_name: 'brands',
                      shopid: storeId || shopInfoVO?.shopId || '-100',
                      ...searchEventTrack,
                    }),
                  })}
                >
                  {t('s.filter.brands')}
                  {searchStore.selectedBrandIds.length > 0 && (
                    <div
                      className={styles.brandNum}
                    >{`(${searchStore.selectedBrandIds.length})`}</div>
                  )}
                  <ArrowDownIcon width={14}></ArrowDownIcon>
                  {/* {searchStore.filterDropdownType === "brand" && <div className={styles.fill}></div>} */}
                </div>
              )}
              {/** best seller */}
              {rankingSearch && searchStore.topKeyVOS?.find((item) => item.id === 'bestseller') && (
                <div
                  className={cn(styles.tag, {
                    [styles.closeActive]: searchStore.selectedTopKeys?.includes('bestseller'),
                  })}
                  onClick={() => {
                    handleToggleTopKeyItem(
                      searchStore.topKeyVOS?.find((item) => item.id === 'bestseller'),
                    );
                  }}
                >
                  {searchStore.topKeyVOS?.find((item) => item.id === 'bestseller')?.name}
                </div>
              )}
              {/*扩展属性筛选项*/}
              {extAttrsForRow && extAttrsForRow.length > 0 && (
                <>
                  {extAttrsForRow.map((item: any, index: number) => (
                    <>
                      <div
                        className={cn(styles.tag, {
                          [styles.opened]: (
                            searchStore.selectedExtAttrs as Record<string, string[]>
                          )[item.id]?.length,
                          [styles.closeActive]:
                            !curAttr.id &&
                            (searchStore.selectedExtAttrs as Record<string, string[]>)[item.id] &&
                            (searchStore.selectedExtAttrs as Record<string, string[]>)[item.id]
                              .length,
                          [styles.openActive]:
                            curAttr.id &&
                            (searchStore.selectedExtAttrs as Record<string, string[]>)[item.id] &&
                            (searchStore.selectedExtAttrs as Record<string, string[]>)[item.id]
                              .length,
                        })}
                        onClick={(e) => {
                          toggleAttrPanel(item);
                          spmTrackingUtils.spmClick({
                            spm: 'a0146.b002226.c00002390.Option',
                            biz_type: '',
                            event_id: 'Search_ProductList_Option',
                            page_id: 'Search_ProductList',
                            json_param: JSON.stringify({
                              keyWord: keyword,
                              categoryId: frontCategoryId || '-100',
                              pvid: logid,
                              mtest: mtest,
                              channelName: 'Search_result',
                              pos: 1 + (searchStore.brands?.length ? 1 : 0) + index,
                              filter_name: item.name,
                              shopid: storeId || shopInfoVO?.shopId || '-100',
                              ...searchEventTrack,
                            }),
                            target: e.target as HTMLElement,
                          });
                        }}
                        data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.01}'
                        data-exp={JSON.stringify({
                          spm: 'a0146.b002226.c00002390.Option',
                          biz_type: '',
                          event_id: 'Search_ProductList_Option_expo',
                          json_param: JSON.stringify({
                            keyWord: keyword,
                            categoryId: highRelatedCategoryIdsForTrack || '-100',
                            logid: searchEventTrack?.logid || '-100',
                            pvid: logid,
                            mtest: mtest,
                            channelName: 'Search_result',
                            pos: 1 + (searchStore.brands?.length ? 1 : 0) + index,
                            filter_name: item.name,
                            shopid: storeId || shopInfoVO?.shopId || '-100',
                          }),
                        })}
                      >
                        <span className={styles.title}>{item.name}</span>
                        {(searchStore.selectedExtAttrs as Record<string, string[]>)[item.id] &&
                        (searchStore.selectedExtAttrs as Record<string, string[]>)[item.id]
                          ?.length ? (
                          <span className={styles.brandNum}>
                            {'(' +
                              (searchStore.selectedExtAttrs as Record<string, string[]>)[item.id]
                                ?.length +
                              ')'}
                          </span>
                        ) : (
                          ''
                        )}
                        <ArrowDownIcon width={14}></ArrowDownIcon>
                        {searchStore.filterDropdownType === item.name && (
                          <div className={styles.fill}></div>
                        )}
                      </div>
                    </>
                  ))}
                </>
              )}
              {/* <div className={cx(styles.rightFade, { [styles.hidden]: isAtEnd })} /> */}
            </div>
            {isOverflow && (
              <div
                className={styles.moreFilterBtn}
                onClick={(e) => {
                  handleToggleArrow(e);
                }}
              >
                <FilterDropIcon />
              </div>
            )}
          </div>

          {/* 小首页不需要展示dropdownPopover弹窗 */}
          {
            <UKDrawer
              className={styles.searchExtraFilterDrawer}
              title={getDrawerTitle()}
              openDrawer={
                searchStore.filterDropdownVisible && searchStore.filterDropdownType === 'sort'
              }
              height={262}
              setOpenDrawer={() => {
                searchStore.setFilterDropdownVisible(false);
                searchStore.setProp('filterDropdownType', '');
              }}
            >
              <div className={styles.dropdownPopover}>
                <div className={styles.dropdownContent}>
                  {searchStore.filterDropdownType === 'sort' && (
                    <div className={styles.sortList}>
                      <FormControl component='fieldset' sx={{ width: '100%' }}>
                        <RadioGroup aria-label='sort' name='sort' value={searchStore.sortType}>
                          <div
                            style={{ marginBottom: '20px' }}
                            className={cn(
                              searchStore.sortType === SortType.sort_default && styles.active,
                            )}
                            data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.01}'
                            data-exp={JSON.stringify({
                              spm: 'a0146.b002226.c00002390.Sortby',
                              biz_type: '',
                              event_id: 'Search_ProductList_Sortby_expo',
                              json_param: JSON.stringify({
                                keyWord: keyword,
                                categoryId: highRelatedCategoryIdsForTrack || '-100',
                                pvid: logid,
                                mtest: mtest,
                                channelName: 'Search_result',
                                sort_type: SortType.sort_default,
                                pos: 0,
                                filter_name: 'sort',
                                shopid: storeId || shopInfoVO?.shopId || '-100',
                                ...searchEventTrack,
                              }),
                            })}
                          >
                            <SafeLink
                              href={getSearchUrl({
                                sortType: SortType.sort_default,
                                topKey: searchStore.selectedTopKeys?.includes('redisstore')
                                  ? 'redisstore'
                                  : '',
                              })}
                              onClick={(e) => {
                                searchStore.setFilterDropdownVisible(false);
                                searchStore.setProp('filterDropdownType', '');
                                if (window.location.pathname === '/s-for-addon') {
                                  isAddon
                                    ? sendClickTrackForAddon.FreeShippingAddOn_SortBtn_Click({
                                        sortName: t('s.filter.recommend'),
                                        sortStatus: 'desc',
                                      })
                                    : sendClickTrackForAddonOne.Promotion_SortBtn_Click({
                                        sortName: t('s.filter.recommend'),
                                        sortStatus: 'desc',
                                      });
                                } else {
                                  spmTrackingUtils.spmClick({
                                    spm: 'a0146.b002226.c00002390.Sortby',
                                    biz_type: '',
                                    event_id: 'Search_ProductList_Sortby',
                                    page_id: 'Search_ProductList',
                                    json_param: JSON.stringify({
                                      keyWord: keyword,
                                      categoryId: highRelatedCategoryIdsForTrack || '-100',
                                      pvid: logid,
                                      mtest: mtest,
                                      channelName: 'Search_result',
                                      sort_type: SortType.sort_default,
                                      shopid: storeId || shopInfoVO?.shopId || '-100',
                                      ...searchEventTrack,
                                    }),
                                    target: e.target as HTMLElement,
                                  });
                                }
                              }}
                            >
                              <Box sx={{ width: '100%' }}>
                                <div className={styles.sortOption}>
                                  <span className={styles.sortText}>{t('s.filter.recommend')}</span>
                                  <Radio
                                    value={SortType.sort_default}
                                    checkedIcon={<BpCheckedIcon />}
                                    icon={<BpIcon />}
                                  />
                                </div>
                              </Box>
                            </SafeLink>
                          </div>
                          <div
                            style={{ marginBottom: '20px' }}
                            className={cn(
                              searchStore.sortType === SortType.sort_dredisprice_desc &&
                                styles.active,
                            )}
                            data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.01}'
                            data-exp={JSON.stringify({
                              spm: 'a0146.b002226.c00002390.Sortby',
                              biz_type: '',
                              event_id: 'Search_ProductList_Sortby_expo',
                              json_param: JSON.stringify({
                                keyWord: keyword,
                                categoryId: highRelatedCategoryIdsForTrack || '-100',
                                pvid: logid,
                                mtest: mtest,
                                channelName: 'Search_result',
                                sort_type: 'sort_price_desc',
                                pos: 0,
                                filter_name: 'sort',
                                shopid: storeId || shopInfoVO?.shopId || '-100',
                                ...searchEventTrack,
                              }),
                            })}
                          >
                            <SafeLink
                              href={getSearchUrl({
                                sortType: SortType.sort_dredisprice_desc,
                                topKey: searchStore.selectedTopKeys?.includes('redisstore')
                                  ? ''
                                  : 'redisstore',
                              })}
                              onClick={(e) => {
                                searchStore.setFilterDropdownVisible(false);
                                searchStore.setProp('filterDropdownType', '');
                                if (window.location.pathname === '/s-for-addon') {
                                  isAddon
                                    ? sendClickTrackForAddon.FreeShippingAddOn_SortBtn_Click({
                                        sortName: t('s.filter.price'),
                                        sortStatus:
                                          searchStore.sortType === SortType.sort_dredisprice_asc
                                            ? 'desc'
                                            : 'asc',
                                      })
                                    : sendClickTrackForAddonOne.Promotion_SortBtn_Click({
                                        sortName: t('s.filter.price'),
                                        sortStatus:
                                          searchStore.sortType === SortType.sort_dredisprice_asc
                                            ? 'desc'
                                            : 'asc',
                                      });
                                } else {
                                  spmTrackingUtils.spmClick({
                                    spm: 'a0146.b002226.c00002390.Sortby',
                                    biz_type: '',
                                    event_id: 'Search_ProductList_Sortby',
                                    page_id: 'Search_ProductList',
                                    json_param: JSON.stringify({
                                      keyWord: keyword,
                                      categoryId: highRelatedCategoryIdsForTrack || '-100',
                                      pvid: logid,
                                      mtest: mtest,
                                      channelName: 'Search_result',
                                      sort_type: 'sort_price_desc',
                                      shopid: storeId || shopInfoVO?.shopId || '-100',
                                      ...searchEventTrack,
                                    }),
                                    target: e.target as HTMLElement,
                                  });
                                }
                              }}
                            >
                              <Box sx={{ width: '100%' }}>
                                <div className={styles.sortOption}>
                                  {t('s.filter.priceDown')}
                                  <Radio
                                    value={SortType.sort_dredisprice_desc}
                                    checkedIcon={<BpCheckedIcon />}
                                    icon={<BpIcon />}
                                  />
                                </div>
                              </Box>
                            </SafeLink>
                          </div>
                          <div
                            style={{ marginBottom: '4px' }}
                            className={cn(
                              searchStore.sortType === SortType.sort_dredisprice_asc &&
                                styles.active,
                            )}
                            data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.01}'
                            data-exp={JSON.stringify({
                              spm: 'a0146.b002226.c00002390.Sortby',
                              biz_type: '',
                              event_id: 'Search_ProductList_Sortby_expo',
                              json_param: JSON.stringify({
                                keyWord: keyword,
                                categoryId: highRelatedCategoryIdsForTrack || '-100',
                                pvid: logid,
                                mtest: mtest,
                                channelName: 'Search_result',
                                sort_type: 'sort_price_asc',
                                pos: 0,
                                filter_name: 'sort',
                                shopid: storeId || shopInfoVO?.shopId || '-100',
                                ...searchEventTrack,
                              }),
                            })}
                          >
                            <SafeLink
                              href={getSearchUrl({
                                sortType: SortType.sort_dredisprice_asc,
                                topKey: searchStore.selectedTopKeys?.includes('redisstore')
                                  ? ''
                                  : 'redisstore',
                              })}
                              onClick={(e) => {
                                searchStore.setFilterDropdownVisible(false);
                                searchStore.setProp('filterDropdownType', '');
                                if (window.location.pathname === '/s-for-addon') {
                                  isAddon
                                    ? sendClickTrackForAddon.FreeShippingAddOn_SortBtn_Click({
                                        sortName: t('s.filter.price'),
                                        sortStatus:
                                          searchStore.sortType === SortType.sort_dredisprice_asc
                                            ? 'desc'
                                            : 'asc',
                                      })
                                    : sendClickTrackForAddonOne.Promotion_SortBtn_Click({
                                        sortName: t('s.filter.price'),
                                        sortStatus:
                                          searchStore.sortType === SortType.sort_dredisprice_asc
                                            ? 'desc'
                                            : 'asc',
                                      });
                                } else {
                                  spmTrackingUtils.spmClick({
                                    spm: 'a0146.b002226.c00002390.Sortby',
                                    biz_type: '',
                                    event_id: 'Search_ProductList_Sortby',
                                    page_id: 'Search_ProductList',
                                    json_param: JSON.stringify({
                                      keyWord: keyword,
                                      categoryId: highRelatedCategoryIdsForTrack || '-100',
                                      pvid: logid,
                                      mtest: mtest,
                                      channelName: 'Search_result',
                                      sort_type: 'sort_price_asc',
                                      shopid: storeId || shopInfoVO?.shopId || '-100',
                                      ...searchEventTrack,
                                    }),
                                    target: e.target as HTMLElement,
                                  });
                                }
                              }}
                            >
                              <Box sx={{ width: '100%' }}>
                                <div className={styles.sortOption}>
                                  {t('s.filter.priceUp')}
                                  <Radio
                                    value={SortType.sort_dredisprice_asc}
                                    checkedIcon={<BpCheckedIcon />}
                                    icon={<BpIcon />}
                                  />
                                </div>
                              </Box>
                            </SafeLink>
                          </div>
                        </RadioGroup>
                      </FormControl>
                    </div>
                  )}
                </div>
              </div>
            </UKDrawer>
          }
          {
            <UKDrawer
              className={styles.searchExtraFilterDrawer}
              title={getDrawerTitle()}
              openDrawer={
                searchStore.filterDropdownVisible && searchStore.filterDropdownType !== 'sort'
              }
              includeBottomBar={true}
              height={drawerHeight}
              bottomBarHeight={86}
              setOpenDrawer={() => {
                searchStore.setFilterDropdownVisible(false);
                searchStore.setProp('filterDropdownType', '');
              }}
            >
              <div
                className={styles.dropdownPopover}
                // @ts-ignore
                ref={(ref) => ref && (drawerNodeRef.current = ref)}
              >
                <div className={styles.dropdownContent}>
                  {searchStore.filterDropdownType && searchStore.filterDropdownType !== 'sort' && (
                    <>
                      <div
                        className={styles.listParent}
                        // style={{ height: getDynamicHeight() }}
                      >
                        <div
                          className={
                            searchStore.filterDropdownType === 'brand'
                              ? styles.brandList
                              : styles.atterList
                          }
                          data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.01}'
                          data-exp={JSON.stringify({
                            spm: 'a0146.b002226.c00002390.Option_Attribute',
                            biz_type: '',
                            event_id: 'Search_ProductList_Option_Attribute_Expo',
                            json_param: JSON.stringify({
                              keyWord: keyword,
                              categoryId: highRelatedCategoryIdsForTrack || '-100',
                              pvid: logid,
                              mtest: mtest,
                              channelName: 'Search_result',
                              pos: searchStore.filterDropdownType === 'brand' ? 1 : 2,
                              filter_name: searchStore.filterDropdownType,
                              shopid: storeId || shopInfoVO?.shopId || '-100',
                              ...searchEventTrack,
                            }),
                          })}
                        >
                          {searchStore.filterDropdownType === 'brand' && (
                            <>
                              {searchStore.brands
                                .slice(0, showBrandCount)
                                ?.map((item: any, index: number) => {
                                  return (
                                    <span
                                      className={styles.brand}
                                      onClick={(e) => {
                                        handleToggleBrandItem(item);
                                        e.stopPropagation();
                                        spmTrackingUtils.spmClick({
                                          spm: 'a0146.b002226.c00002389.BrandFilter',
                                          biz_type: '',
                                          event_id: 'Search_ProductList_BrandFilter',
                                          page_id: 'Search_ProductList',
                                          json_param: JSON.stringify({
                                            brand_name: item.brandName,
                                            brandid: item.value,
                                            categoryId: highRelatedCategoryIdsForTrack || '-100',
                                            channelName: 'Search_result',
                                            index: index,
                                            keyWord: keyword,
                                            pvid: logid,
                                            mtest: mtest,
                                            shopid: storeId || shopInfoVO?.shopId || '-100',
                                            ...searchEventTrack,
                                          }),
                                          target: e.target as HTMLElement,
                                        });
                                      }}
                                      key={item.value}
                                      data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.01}'
                                      data-exp={JSON.stringify({
                                        spm: 'a0146.b002226.c00002389.BrandFilter',
                                        biz_type: '',
                                        event_id: 'Search_ProductList_BrandFilter_Expo',
                                        json_param: JSON.stringify({
                                          brand_name: item.brandName,
                                          brandid: item.value,
                                          categoryId: highRelatedCategoryIdsForTrack || '-100',
                                          channelName: 'Search_result',
                                          index: index,
                                          keyWord: keyword,
                                          pvid: logid,
                                          mtest: mtest,
                                          shopid: storeId || shopInfoVO?.shopId || '-100',
                                          ...searchEventTrack,
                                        }),
                                      })}
                                    >
                                      <span
                                        className={cn(
                                          styles.brandName,
                                          searchStore.selectedBrandIds.includes(item.value)
                                            ? styles.active
                                            : '',
                                        )}
                                      >
                                        {item.brandName}
                                      </span>
                                    </span>
                                  );
                                })}
                              {showBrandLoadMoreBtn && (
                                <span
                                  className={styles.showMore}
                                  onClick={() => {
                                    setShowBrandCount((prevCount) => prevCount + 30);
                                  }}
                                >
                                  <DropDownIcon />
                                </span>
                              )}
                            </>
                          )}
                          {searchStore.filterDropdownType !== 'brand' &&
                            curAttr?.saleAttrs.map((item: any) => {
                              return (
                                <div className={styles.attr} key={item.id}>
                                  <span
                                    className={cn(
                                      styles.attrName,
                                      (searchStore.selectedExtAttrs as Record<string, string[]>)[
                                        curAttr.id
                                      ]?.includes(item.id)
                                        ? styles.active
                                        : '',
                                    )}
                                  >
                                    {item.name}
                                  </span>
                                  <UKCheckbox
                                    checked={
                                      !!(searchStore.selectedExtAttrs as Record<string, string[]>)[
                                        curAttr.id
                                      ]?.includes(item.id)
                                    }
                                    onClick={(e) => {
                                      handleToggleAttrItem(curAttr.id, item.id);
                                      e.stopPropagation();
                                    }}
                                    sx={{ paddingRight: 0 }}
                                  />
                                </div>
                              );
                            })}
                        </div>
                      </div>

                      <div className={styles.buttons}>
                        <Button
                          className={cn(styles['button'], styles['resetButton'])}
                          sx={{ borderRadius: '4px', height: '36px' }}
                          variant='outlined'
                          onClick={handleReset}
                        >
                          {t('s.filter.reset')}
                        </Button>
                        <Button
                          className={styles['button']}
                          sx={{ borderRadius: '4px', height: '36px' }}
                          variant='contained'
                          startIcon={searchStore.isFetching ? <LoadingIcon /> : null}
                          onClick={(e) => {
                            handleCloseDropDownPopover(e); // 关闭弹窗 + 埋点
                            showFilterToast(); // 0 结果提示
                          }}
                        >
                          {searchStore.isFetching
                            ? null
                            : t('s.filter.showNumResults', {
                                num: formatInteger(searchStore.resultShowCount as number),
                              })}
                        </Button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </UKDrawer>
          }
        </div>

        {/*Filter 抽屉组件*/}
        <UKDrawer
          className={styles.searchFilterDrawer}
          title={t('s.filter.allFilters')}
          openDrawer={isOpenFilterDrawer}
          includeBottomBar={true}
          height={drawerHeight}
          bottomBarHeight={86}
          setOpenDrawer={() => {
            setIsOpenFilterDrawer(false);
          }}
        >
          <div
            className={styles.filterArea}
            // @ts-ignore
            ref={(ref) => ref && (drawerNodeRef.current = ref)}
            data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.01}'
            data-exp={JSON.stringify({
              spm: 'a0146.b002226.c00002390.ExpandAttribute',
              biz_type: '',
              event_id: 'Search_ProductList_ExpandAttribute_Expo',
              json_param: JSON.stringify({
                keyWord: keyword,
                categoryId: highRelatedCategoryIdsForTrack || '-100',
                pvid: logid,
                mtest: mtest,
                channelName: 'Search_result',
                shopid: storeId || shopInfoVO?.shopId || '-100',
                ...searchEventTrack,
              }),
            })}
          >
            {searchStore.topKeyVOS && searchStore.topKeyVOS.length > 0 && (
              <div>
                {searchStore.topKeyVOS.map((item: any, index: number) => (
                  <div key={item.name} className={styles.topKeyVOS}>
                    <span
                      key={item.name}
                      data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.01}'
                      data-exp={JSON.stringify({
                        spm: 'a0146.b002226.c00002390.ExpandAttributeItem',
                        biz_type: '',
                        event_id: 'Search_ProductList_ExpandAttributeItem_Expo',
                        json_param: JSON.stringify({
                          keyWord: keyword,
                          categoryId: highRelatedCategoryIdsForTrack || '-100',
                          pvid: logid,
                          mtest: mtest,
                          channelName: 'Search_result',
                          filter_name: item.name,
                          pos: index,
                          shopid: storeId || shopInfoVO?.shopId || '-100',
                          ...searchEventTrack,
                        }),
                      })}
                    >
                      {item.name}
                    </span>
                    <UKSwitch
                      checked={searchStore.selectedTopKeys?.includes(item.id)}
                      onChange={() => {
                        handleToggleTopKeyItem(item);
                      }}
                      sx={{
                        // 关闭状态轨道
                        '& .MuiSwitch-track': {
                          backgroundColor: '#e5e7eb',
                        },
                      }}
                    />
                  </div>
                ))}
                {channelPageName && (
                  <div className={styles.topKeyVOS}>
                    <span
                      onClick={() => {
                        handleToggleMiniPagePanel();
                      }}
                    >
                      {t('s.in', { channelPageName: channelPageName })}
                    </span>
                    <UKSwitch
                      checked={searchStore.selectedTopKeys.includes('channel_page_filter')}
                      onChange={() => {
                        handleToggleMiniPagePanel();
                      }}
                      sx={{
                        // 关闭状态轨道
                        '& .MuiSwitch-track': {
                          backgroundColor: '#e5e7eb',
                        },
                      }}
                    />
                  </div>
                )}
              </div>
            )}
            {searchStore.minPrice !== '' && searchStore.maxPrice !== '' ? (
              <>
                <div className={styles.titleWrapper} onClick={handleTogglePrice}>
                  <span className={styles.title}>{t('s.filter.price')}</span>
                  <ArrowDownIcon
                    width={24}
                    className={priceCollapse ? styles.arrowUp : ''}
                  ></ArrowDownIcon>
                </div>
                {!priceCollapse ? (
                  <div className={styles.priceTool}>
                    <PriceSlider
                      onSearch={() => onSearch()}
                      baseUrl={baseUrl}
                      localInfo={localInfo}
                    />
                  </div>
                ) : null}
              </>
            ) : null}

            {searchStore.brandExist && (
              <>
                <div className={styles.titleWrapper} onClick={handleToggleBrand}>
                  <span className={styles.title}>{t('s.filter.brand')}</span>
                  <ArrowDownIcon
                    width={24}
                    className={brandCollapse ? styles.arrowUp : ''}
                  ></ArrowDownIcon>
                </div>
                {!brandCollapse ? (
                  <div className={styles.tags}>
                    {searchStore.brands
                      .slice(0, visibleBrandCount)
                      .map((item: any, index: number) => (
                        <span
                          key={item.brandName}
                          onClick={() => handleToggleBrandItem(item)}
                          className={
                            searchStore.selectedBrandIds.includes(item.value) ? styles.active : ''
                          }
                          data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.01}'
                          data-exp={JSON.stringify({
                            spm: 'a0146.b002226.c00002390.ExpandAttributeItem',
                            biz_type: '',
                            event_id: 'Search_ProductList_ExpandAttributeItem_Expo',
                            json_param: JSON.stringify({
                              keyWord: keyword,
                              categoryId: highRelatedCategoryIdsForTrack || '-100',
                              pvid: logid,
                              mtest: mtest,
                              channelName: 'Search_result',
                              filter_name: item.brandName,
                              pos: index,
                              shopid: storeId || shopInfoVO?.shopId || '-100',
                              ...searchEventTrack,
                            }),
                          })}
                        >
                          {item.brandName}
                        </span>
                      ))}
                    {/* 下拉箭头的展示 */}
                    {showLoadMoreButton && (
                      <span
                        className={styles.showLoadMore}
                        onClick={() => {
                          setVisibleBrandCount(
                            (prevCount) => prevCount + searchStore.brandFoldedCount,
                          );
                          if (
                            visibleBrandCount + searchStore.brandFoldedCount >=
                            searchStore.brands.length
                          ) {
                            setShowMore(true);
                          }
                        }}
                      >
                        <DropDownIcon />
                      </span>
                    )}
                    {/* 如果全部展示后可以使用品牌横条收起 */}
                    {/* {showMore && (
                    <span onClick={() => {
                      setVisibleBrandCount(searchStore.brandFoldedCount);
                      setShowMore(false);
                    }}>收起</span>
                  )} */}
                  </div>
                ) : null}
              </>
            )}

            {/* 和一级筛选保持统一，不展示如size这些 */}
            {searchStore.extAttrCollection?.map((item: any) => {
              return (
                <>
                  <div className={styles.titleWrapper} onClick={() => handleToggleAttr(item)}>
                    <span className={styles.title}>{item.name}</span>
                    <ArrowDownIcon
                      width={24}
                      className={item.collapse ? styles.arrowUp : ''}
                    ></ArrowDownIcon>
                  </div>
                  {!item.collapse ? (
                    <div className={styles.tags}>
                      {item.saleAttrs
                        .slice(0, attrShowCountMap[item.id])
                        .map((attr: any, index: number) => (
                          <span
                            key={attr.name}
                            className={
                              (searchStore.selectedExtAttrs as Record<string, string[]>)[
                                item.id
                              ]?.includes(attr.id)
                                ? styles.active
                                : ''
                            }
                            onClick={() => handleToggleAttrItem(item.id, attr.id)}
                            data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.01}'
                            data-exp={JSON.stringify({
                              spm: 'a0146.b002226.c00002390.ExpandAttributeItem',
                              biz_type: '',
                              event_id: 'Search_ProductList_ExpandAttributeItem_Expo',
                              json_param: JSON.stringify({
                                keyWord: keyword,
                                categoryId: highRelatedCategoryIdsForTrack || '-100',
                                pvid: logid,
                                mtest: mtest,
                                channelName: 'Search_result',
                                filter_name: attr.name,
                                pos: index,
                                shopid: storeId || shopInfoVO?.shopId || '-100',
                                ...searchEventTrack,
                              }),
                            })}
                          >
                            {attr.name}
                          </span>
                        ))}
                      {/* 下拉箭头的展示 */}
                      {showLoadMoreSalesAtterButton(item.id) && (
                        <span
                          className={styles.showLoadMore}
                          onClick={() => {
                            setAttrShowCountMap((prev) => ({
                              ...prev,
                              [item.id]: Math.min(
                                prev[item.id] + searchStore.extAttributeFoldedCount,
                                item.saleAttrs.length,
                              ),
                            }));
                          }}
                        >
                          <DropDownIcon />
                        </span>
                      )}
                    </div>
                  ) : null}
                </>
              );
            })}
          </div>

          <div className={styles['buttons']}>
            {/* @ts-ignore */}
            <Button
              className={styles['button']}
              sx={{ borderRadius: '4px', height: '40px' }}
              variant='outlined'
              loading
              onClick={handleReset}
            >
              {t('s.filter.reset')}
            </Button>
            {/* @ts-ignore */}
            <Button
              className={styles['button']}
              sx={{ borderRadius: '4px', height: '40px', boxShadow: 'none' }}
              variant='contained'
              loading={searchStore.isFetching.toString()}
              startIcon={searchStore.isFetching ? <LoadingIcon /> : null}
              onClick={(e) => handleShowResult(e)}
            >
              {searchStore.isFetching
                ? null
                : t('s.filter.showNumResults', {
                    num: formatInteger(searchStore.resultShowCount as number),
                  })}
            </Button>
          </div>
        </UKDrawer>
      </>
    );
  },
);

export default Filter;
